// extracted by mini-css-extract-plugin
export var divider = "_rd-0";
export var systemMessage = "_rd-1";